import { useEffect, useState } from "react";
import clsx from "clsx";

import { ApiClient } from "/api/client";
import MaperOld from "../../pages/contacts/maperOld";

import styles from "./index.module.scss";

/** Карта ПВЗ СДЭК для заданного города (spb/msk на /delivery/). */
export default function SdekMap({ cityName, isBaltex }) {
  const [points, setPoints] = useState([]);

  useEffect(() => {
    if (!cityName) {
      setPoints([]);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      const response = await ApiClient.sdek.getPointsNew(cityName);
      if (!cancelled) {
        setPoints(Array.isArray(response) ? response : []);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [cityName]);

  return (
    <div className={clsx(styles.Adreses, isBaltex && styles.AdresesBaltex)}>
      <div className={styles.Map}>
        <MaperOld zoom={10} points={points} />
      </div>
    </div>
  );
}
